/**
 * Synchronous WebGPU support check. Reads `?renderer=webgl|webgpu`
 * from the URL to allow forcing a backend.
 *
 * NOTE: WebGL2 is the default. WebGPU has known issues with
 * drei `<Text>` (Troika SDF) and `transparent: true` materials on
 * three's WebGPU backend; opt in only via `?renderer=webgpu`.
 *
 * NOTE: this is a regular function (not a React hook); the `use*`
 * naming follows project convention. Safe to call during render.
 */
export function useWebGPUSupport(): boolean {
  if (typeof navigator === 'undefined') return false;
  const params = new URLSearchParams(window.location.search);
  const force = params.get('renderer');
  if (force === 'webgpu') return 'gpu' in navigator;
  // Default + 'webgl' → WebGL2
  return false;
}
